<template>

        <v-container fluid >
          <v-row>
            <v-col
              cols="4"
            >
            <v-card>
             <div >

                <apexchart type="bar" height="300" ref="furush" :options="prodaja_vozvrat_options" :series="prodaja_vozvrat"></apexchart>
            </div>
            </v-card>


            </v-col>

            <v-col
            cols="4"
          >
          <v-card>
            <div >
                <apexchart type="pie" ref="ost_kassa" height="700" width="420"  :options="chartOptions" :series="series"></apexchart>
                <br>
                <br>
                <br>
                <h5><pre>       Всего касса: {{ Number(Number(this.eskhata)+Number(this.ost_kassa)+Number(this.dc)+Number(this.alif)).toFixed(2) }}TJS</pre></h5>
              </div>
          </v-card>
          </v-col>

          <v-col
          cols="4"
        >
        <v-card>
         <div >

          <apexchart type="bar" height="300" ref="top_foida" :options="chartOptions_pribil" :series="series_pribil"></apexchart>
        </div>
        </v-card>



        </v-col>

          </v-row>

          <v-row>

            <v-col
            cols="4"
          >
          <v-card>
           <div >

            <apexchart type="bar" height="300" ref="top_tovar" :options="chartOptions_top_tovar" :series="series_top_tovar"></apexchart>
          </div>
          </v-card>
          </v-col>
          <v-col
          cols="4"
        >
        <v-card>
         <div >
            <apexchart type="bar" height="300" ref="top_klents" :options="chartOptions_top_klents" :series="series_top_klents"></apexchart>

        </div>
        </v-card>
        </v-col>

            <v-col
            cols="4"
        >
        <v-card>
        <div>
            <apexchart type="bar" height="300" ref="top_partners" :options="chartOptions_top_partners" :series="series_top_partners"></apexchart>
        </div>
        </v-card>
        </v-col>

          </v-row>


        </v-container>

</template>

<script>
import ostatok_kassa from '../components/O_Kassa/ostatok_kassa.vue'

export default {
  components: { ostatok_kassa },

        data: () => ({

            loading: false,
            prodaja_vozvrat: [ ],

        prodaja_vozvrat_options: {
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 5,
                dataLabels: {



                  // total: {
                  //   enabled: true,
                  //   style: {
                  //     fontSize: '8px',
                  //     fontWeight: 900
                  //   }
                  // }
                }
              },

            },
            xaxis: {
              type: 'date',
              categories: [
              ],
            },
            legend: {
              position: 'right',
              offsetY: 40
            },
            fill: {
              opacity: 1
            },
            title: {
                text: 'Продажа и возврат за 7 дней',
                align: 'center',
                floating: true
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return   val + " TJS"
                }
              }
            }
        },




        //   top  klents


        series_top_klents: [{
            name: '',
            data: []
          }],
          chartOptions_top_klents: {
            chart: {
              type: 'bar',
              height: 380
            },
            plotOptions: {
              bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                },
              }
            },
            colors: ['#039C0D', '#18AE22', '#71CF2A', '#B3DC2D', '#CCE338', '#FFF200', '#FF9F18', '#FF6127',
              '#EC1C24', '#88001B'
            ],

            // colors: ['#88001B', '#EC1C24', '#FF6127', '#FF9F18', '#FFF200', '#CCE338', '#B3DC2D', '#71CF2A', '#18AE22', '#039C0D'],
            dataLabels: {
              enabled: false,
              textAnchor: 'start',
              style: {
                colors: ['#fff']

              },
              formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              },
              offsetX: 0,
              dropShadow: {
                enabled: true
              }
            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              labels: {
                show: false
              }
            },
            title: {
                text: 'Топ 10 клиентов',
                align: 'center',
                floating: true
            },
            subtitle: {
                text: 'Топ 10 активных клиентов за 7 дней',
                align: 'center',
            },
            tooltip: {
              theme: 'dark',
              x: {
                show: false
              },
              y: {
                title: {
                   formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              },
                }
              }
            }
          },


          // top tovar


          series_top_tovar: [{
            name: '',
            data: []
          }],

          chartOptions_top_tovar: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [],
            },
            title: {
                text: 'Топ 10 проданных товаров',
                align: 'center',
                floating: true
            },
            subtitle: {
                text: 'Топ 10 проданных товаров ',
                align: 'center',
            },
          },


        //   top partners



        series_top_partners: [{
            name: '',
            data: []
          }],

          chartOptions_top_partners: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: true,
              }
            },
            colors: ['#039C0D'],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [],
            },
            title: {
                text: 'Топ 10 лучших партнеров',
                align: 'center',
                floating: true
            },
            subtitle: {
                text: 'Топ 10 лучших партнеров ',
                align: 'center',
            },
          },

        //   pribil

        series_pribil: [{
            name: 'Прибиль',
            data: []
          }],
          chartOptions_pribil: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                colors: {
                  ranges: [{
                    from: -100,
                    to: -46,
                    color: '#F15B46'
                  }, {
                    from: -45,
                    to: 0,
                    color: '#FEB019'
                  }]
                },
                columnWidth: '80%',
              }
            },
            dataLabels: {
              enabled: false,
            },
            yaxis: {

              labels: {
                formatter: function (y) {
                  return y.toFixed(0) + "TJS";
                }
              }
            },
            xaxis: {
                type: 'date',
              categories: [],
              labels: {
                rotate: -90
              }
            },
            title: {
                text: 'Чистий прибиль',
                align: 'center',
                floating: true
            },
            subtitle: {
                text: ' ',
                align: 'center',
            },
          },



          series: [],



chartOptions: {
  chart: {
    width: 500,
    type: 'pie',
  },

  title: {
                text: 'Остаток касса',
                align: 'center',
                floating: true
            },
            subtitle: {
                text: ' ',
                align: 'center',
            },


            legend: {
                formatter: function(val, opts) {
                return val + "  " + opts.w.globals.series[opts.seriesIndex]
                }
            },


            labels: ["Эсхата", "Наличные деньги", "Душанбе сити", " Алиф"],
            responsive: [{
                breakpoint: 480,
                options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom',

                },



                }
            }]
            },


            loading: false,
            kkk:[],
            alif:"0",
            dc:"0",
            eskhata:"0",
            ost_kassa:"0",




    }),

    mounted() {

          this.get_furush_chart();
          this.get_top_tovars();
         this.get_top_klents();
         this.get_top_partners();
         this.get_top_foida();
         this.get_kassa();
    },

    methods: {

        get_kassa() {

            axios.get('/api/get_ost_kassa',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){

                                    this.alif= response.data.alif;
                                    this.eskhata= response.data.eskhata;
                                    this.dc= response.data.dc;
                                    this.ost_kassa= response.data.ost_kassa;


                                  this.$refs.ost_kassa.updateSeries(
                                     [
                                        Number(this.eskhata),Number(this.ost_kassa),Number(this.dc),Number(this.alif)
                                     ]

                                  )





                              }
                          })
                          .catch(error => {

                          });
        },

        get_furush_chart() {

            axios.get('/api/get_furush_chart',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){

                                 // console.log(response.data.sana)
                                 // this.prodaja_vozvrat_options.xaxis.categories = response.data.sana;
                               //   console.log(this.prodaja_vozvrat_options['xaxis']['categories'])
                                  this.prodaja_vozvrat = response.data.prodaja_vozvrat;

                                //   this.$refs.furush.updateSeries([{
                                //     data: response.data.prodaja_vozvrat
                                //   }])

                                  this.$refs.furush.updateOptions({
                                    xaxis: {
                                        categories: response.data.sana //ie ["a","b","c","d"]
                                    }
                                })


                              }
                          })
                          .catch(error => {
                              this.loading = false;

                          });
        },

        get_top_tovars() {

            axios.get('/api/get_top_tovars',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){

                                //  this.series_top_tovar = response.data.foida;

                                  this.$refs.top_tovar.updateSeries([{
                                    data: response.data.foida
                                  }])


                                  this.$refs.top_tovar.updateOptions({
                                    xaxis: {
                                        categories: response.data.nom //ie ["a","b","c","d"]
                                    }
                                })


                              }
                          })
                          .catch(error => {


                          });
        },

        get_top_klents() {

            axios.get('/api/get_top_klents',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){



                                  this.$refs.top_klents.updateSeries([{
                                    data: response.data.itog
                                  }])


                                  this.$refs.top_klents.updateOptions({
                                    xaxis: {
                                        categories: response.data.nom
                                    }
                                })


                              }
                          })
                          .catch(error => {
                            console.log(error.response.data.message);
                          });
        },

        get_top_partners() {
            this.loading = true;
            axios.get('/api/get_top_partners',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                //  this.series_top_tovar = response.data.foida;

                                  this.$refs.top_partners.updateSeries([{
                                    data: response.data.itog
                                  }])


                                  this.$refs.top_partners.updateOptions({
                                    xaxis: {
                                        categories: response.data.nom //ie ["a","b","c","d"]
                                    }
                                })


                              }
                          })
                          .catch(error => {
                              this.loading = false;

                          });
        },

        get_top_foida() {
            this.loading = true;
            axios.get('/api/get_top_foida',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                //  this.series_top_tovar = response.data.foida;

                                  this.$refs.top_foida.updateSeries([{
                                    data: response.data.foida
                                  }])


                                  this.$refs.top_foida.updateOptions({
                                    xaxis: {
                                        categories: response.data.sana //ie ["a","b","c","d"]
                                    }
                                })


                              }
                          })
                          .catch(error => {
                              this.loading = false;

                          });
        },
    }



}
</script>

<style>

</style>





